import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import theme from "src/styles/theme";
import GlobalStyles from "./styles/globalStyle";
import { ThemeProvider } from "styled-components";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <GlobalStyles />
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);
